export const ENV={
    NAME:process.env.REACT_APP_ENV,
    API_URL:process.env.REACT_APP_API_URL,
    URL_APP:process.env.REACT_APP_URL,
    API_KEY_URL:process.env.REACT_APP_KEY_URL,
    API_KEY_URL_BEN:process.env.REACT_APP_URL_BEN,
    DECRYPTION_KEY:process.env.REACT_APP_DECRYPTION_KEY
}